import React from 'react';
import { useLockBodyScroll } from '@yme/hooks/useLockBodyScroll';
import { useOutsideClick } from '@yme/hooks/useOutsideClick';
import { EVENT_NAME_MAP } from '@yme/utils/constants';
import { NestedContainerStyled } from './styled';
export function NestedMenuContainer({ onCloseMenu, children, isRightToLeft, }) {
    const { elementRef } = useOutsideClick({
        eventName: EVENT_NAME_MAP.click,
        callback: onCloseMenu,
        options: true,
    });
    useLockBodyScroll();
    return (React.createElement(NestedContainerStyled, { isRightToLeft: isRightToLeft, ref: elementRef }, children));
}
